import React from 'react';
import { ResultEntry } from './ResultEntry';

export function SearchResult(props){

  
    return (
      <div className="container">
        {props.results && props.results.map(r => <ResultEntry key={r.productPageUrl} value={r} onSelect={props.onSelect} onShowProduct={props.onShowProduct} />)}
      </div>
    );
  
}
